// shortReason — the rule ReasonCell uses to decide what a row shows (the first
// clause of a long explanation; the full text goes on hover). Its own plain
// module so a node test can pin it without a JSX loader.
//
// SHORT = the text up to its earliest clause break (" — ", ": ", ", so "),
// capped at `max` characters on a word boundary. The writers of these sentences
// already put the WHAT first and the WHY/HOW after a dash or colon, so the cut
// lands where the reading does.

export const REASON_MAX = 60;
const BREAKS = [' — ', ': ', ', so '];

export function shortReason(text, max = REASON_MAX) {
  const full = String(text ?? '').trim();
  if (!full) return { short: '', cut: false };
  let short = full;
  for (const b of BREAKS) {
    const i = short.indexOf(b);
    if (i > 0) short = short.slice(0, i);
  }
  if (short.length > max) {
    const sp = short.lastIndexOf(' ', max);
    short = short.slice(0, sp >= max / 2 ? sp : max);
  }
  short = short.replace(/[\s,;:—-]+$/, '');
  return { short, cut: short !== full };
}
